import { dateHeader, formatCellDate } from './timeModeCell';

export const makeManageSuperSentinelBulkActivationColumn = (handleViewSummary: (data: any) => void) => {
  const col = [
    {
      header: 'Summary',
      sortable: false,
      enableColumnFilter: false,
      size: 150,
      cell: ({ row }) => (
        <div style={{ cursor: 'pointer' }} onClick={() => handleViewSummary(row.original)}>
          <span style={{ textDecoration: 'underline' }}>Detail summary</span>
        </div>
      ),
    },
    {
      header: 'User Name',
      accessorKey: 'userName',
      size: 140,
    },
    {
      header: 'Total Devices',
      accessorKey: 'totalDevices',
      size: 140,
    },
    {
      header: 'Processed',
      accessorKey: 'statusSummary.processed',
      size: 130,
      cell: ({ row }) => <span>{row.original.statusSummary?.processed ?? 0}</span>,
    },
    {
      header: 'Pending',
      accessorKey: 'statusSummary.pending',
      size: 120,
      cell: ({ row }) => <span>{row.original.statusSummary?.pending ?? 0}</span>,
    },
    {
      header: 'Failed Devices',
      accessorKey: 'statusSummary.error',
      size: 140,
      cell: ({ row }) => <span>{row.original.statusSummary?.error ?? 0}</span>,
    },
    {
      header: 'Status',
      sortable: false,
      enableColumnFilter: false,
      size: 180,
      cell: ({ row }) => {
        const { error = 0, pending = 0, processing = 0, processed = 0, total = 0 } = row.original.statusSummary ?? {};

        if (pending > 0 || processing > 0) return <span>In Progress</span>;

        if (error > 0 && error === total) return <span>Failed</span>;
        if (error > 0) return <span>Completed With Errors</span>;
        if (processed === total && total > 0) return <span>Successful</span>;

        return <span>Unknown</span>;
      },
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      enableColumnFilter: true,
      sortable: true,
      size: 160,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
  ] as Array<any>;

  return col;
};
